/**
 * 修改标题
 */
export default {
  inserted(el, binding) {
    document.title = binding.value;
  },
  unbind() {
    document.title = '';
  },
};
